const parseCookies = (cookie) => {
  const cookies = {};
  if (!cookie) {
    cookie = document.cookie;
  }
  if (cookie === '') {
    return cookies;
  }
  cookie.split(/;\s*/).forEach(wholeCookie => {
    const parts = wholeCookie.split('=');
    const name = parts.shift();
    const value = parts.join('=').replace(/(^"|"$)/, '');
    cookies[name] = value;
  });
  return cookies;
};

export const authData = (cookie) => {
  const cookies = parseCookies(cookie);
  if (!cookies['auth']) {
    return null;
  }
  const parts = cookies['auth'].split('.');
  try {
    const data = JSON.parse(atob(parts[0]));
    return data;
  } catch (err) {
    return null;
  }
};
